import { useTranslation } from 'react-i18next';
import { Loader } from 'components/Loader';
import { getCameraActions, PageLayout } from 'components/PageLayout';
import { useGeoEvent } from 'features/geoEvents/hooks/useGeoEvent';
import { useLocation } from 'react-router-dom';
import { useSelectedGeoEventId } from 'features/geoEvents/hooks/useSelectedGeoEventId';
import { AnyGeoEvent } from 'features/geoEvents/anyGeoEvent.types';
import { useMapMode } from 'hooks/useMapMode';
import { HomeContent } from './HomeContent';
import { useHandleExternalPaymentSuccess } from './useHandleExternalPaymentSuccess';
import { useAdminMenuItems } from './useAdminMenuItems';
import { useAppUpgradeNotification } from '../../../hooks/useAppUpgradeNotification';

export const Home = (): JSX.Element => {
  const { isPending } = useHandleExternalPaymentSuccess();
  const { t } = useTranslation();
  const { geoEvent } = useGeoEvent<AnyGeoEvent>({
    id: useSelectedGeoEventId(),
    useCacheBuster: true,
  });
  const location = useLocation<{ fromRoute?: string }>();
  const { isTimelineMode } = useMapMode();
  const adminMenuItems = useAdminMenuItems();

  useAppUpgradeNotification();

  const geoEventId =
    geoEvent?.data.geoEventType === 'wildfire' ? geoEvent.id : undefined;

  const cameraAction = getCameraActions(
    t,
    geoEventId ? `/add_report/${geoEventId}?moderated=false` : '/add_report',
  );

  const fromRoute = location.state?.fromRoute || '';

  return (
    <PageLayout
      data-cname="HomePage"
      data-testid="homePage"
      headerBarProps={{
        iconActions: cameraAction,
        menuSections: adminMenuItems,
        action: fromRoute ? 'back' : undefined,
        forceDark: isTimelineMode,
      }}
    >
      <HomeContent />
      {isPending && <Loader />}
    </PageLayout>
  );
};
